<!-- 未加入メッセージ画面 -->
<template>
  <div> 
    <CrlyAtomsCommonTitleBarMain :title="messageItem.title" />
    <section class="crly-o-error-not-member crly-o-error-not-member--center">
      <p class="crly-o-error-not-member__mb16 crly-line-feed">
        {{ messageItem.text }}
      </p>
      <CrlyAtomsCommonBtnLinkMainColor
        :label="messageItem.label"
        :linkName="messageItem.linkName"
        class="--border --btn-lg"
      />
    </section>
    </div>
</template>

<script>
import CrlyAtomsCommonTitleBarMain from "@crly/components/atoms/common/TitleBarMain.vue";
import CrlyAtomsCommonBtnLinkMainColor from "@crly/components/atoms/common/btn/LinkMainColor.vue";
export default {
  name: "CrlyOrganismsErrorErrorNotMember",
  components: {
    CrlyAtomsCommonTitleBarMain,
    CrlyAtomsCommonBtnLinkMainColor
  },
  data() {
    return {
      messageItem: {
        title: this.$t("enrollment.entryNotYet.title"),
        text: this.$t("enrollment.entryNotYet.text"),
        label: this.$t("enrollment.entryNotYet.btn"),
        linkName: "CrlyEntry",
        showImage: false
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@crly/assets/css/organisms/error/errorNotMember.scss";
</style>
